(function ($, Drupal, dBlazy, drupalSettings, once) {

  'use strict';

  Drupal.behaviors.heroslider = {
    attach: function (context) {
      var me = Drupal.blazy;
      var el = context.querySelector('[data-blazy]');
      if (el === null) {
        me.init = new Blazy(me.globals()); // eslint-disable-line no-undef
      }
      var heroSlider = $(once('slick-slider', '.hero-slider', context));
      var heroSliderWrap = $('.paragraph--type-hero-slider');

      heroSliderWrap.imagesLoaded(function () {
        heroSliderWrap.addClass('processed');
      });

      if (heroSlider.length) {
        heroSlider.each(function () {
          if ($(this).find('img').length > 1) {
            $(this).slick({
              slidesToShow: 1,
              fade: true,
              autoplay: true,
              autoplaySpeed: 4000,
              speed: 1000,
              arrows: false
            });

            $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
              me.init.revalidate();
            });
          }
        });
      }
    }
  };

})(jQuery, Drupal, dBlazy, drupalSettings, once); // eslint-disable-line no-undef
